export const ArrowLeft = () => {
  return (
    <svg
      width="16"
      height="24"
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.793 4.29291L12.2073 5.70712L5.91436 12L12.2073 18.2929L10.793 19.7071L3.08594 12L10.793 4.29291Z"
        fill="white"
      />
    </svg>
  );
};

export const ArrowRight = () => {
  return (
    <svg
      width="16"
      height="24"
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.20696 4.29291L3.79274 5.70712L10.0856 12L3.79274 18.2929L5.20696 19.7071L12.9141 12L5.20696 4.29291Z"
        fill="white"
      />
    </svg>
  );
};
